<form class="header-search" novalidate (submit)="submit($event)">
  <input
    type="search"
    autocomplete="off"
    aria-label="Buscar destino o experiencia"
    [placeholder]="placeholder() | translate"
    [formControl]="query"
  />

  <button type="submit" aria-label="Buscar">
    <i class="fa-solid fa-magnifying-glass header-search__icon" aria-hidden="true"></i>
  </button>
</form>
